import React from 'react'
import Skeleton from 'react-loading-skeleton'

import 'react-loading-skeleton/dist/skeleton.css'

type PropsBlackSkeleton = {
  height?: string
  width?: string
}

export const blackSkeleton = ({
  height,
  width,
}: PropsBlackSkeleton): JSX.Element => {
  const onyxGray = '#3B4050'
  const highlightOnyxGray = '#474d61'

  return (
    <>
      <Skeleton
        baseColor={onyxGray}
        highlightColor={highlightOnyxGray}
        borderRadius='20px'
        height={height}
        width={width}
      />
    </>
  )
}
